module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/landkit-figma-5bf737ba0096ecc9809c40fde235f230.png";